// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import Bar, { BarRow } from './Bar';
import styles from './BarListPanel.module.css';

export type { BarTone, BarRow } from './Bar';

interface BarListPanelProps {
  title: string;
  bars: BarRow[];
}

/** Horizontal, labelled bar-chart panel used across the Home dashboard's section summaries. */
export default function BarListPanel({ title, bars }: BarListPanelProps) {
  return (
    <div className={styles.panel}>
      <div className={styles.title}>{title}</div>
      <div className={styles.bars}>
        {bars.map(bar => (
          <Bar key={bar.label} {...bar} />
        ))}
      </div>
    </div>
  );
}
